import { render, staticRenderFns } from "./reserveOrderList.vue?vue&type=template&id=ebb281ac&scoped=true"
import script from "./reserveOrderList.vue?vue&type=script&lang=js"
export * from "./reserveOrderList.vue?vue&type=script&lang=js"
import style0 from "./reserveOrderList.vue?vue&type=style&index=0&id=ebb281ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb281ac",
  null
  
)

export default component.exports